import axios from 'axios';

// Normalize: strip trailing slashes, then strip trailing /api if present
const raw = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
const BACKEND_URL = raw.endsWith('/api') ? raw.slice(0, -4) : raw;
const API_BASE = `${BACKEND_URL}/api`;

const API = axios.create({ baseURL: API_BASE });

// Add timestamp to GET requests to prevent caching
API.interceptors.request.use(config => {
  if (config.method === 'get') {
    config.params = { ...config.params, _t: Date.now() };
  }
  const token = localStorage.getItem('ap_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 - try refresh token
API.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.status === 401 && !error.config._retry) {
      error.config._retry = true;
      const refresh = localStorage.getItem('ap_refresh');
      if (refresh) {
        try {
          const res = await axios.post(`${API_BASE}/auth/refresh`, null, {
            headers: { Authorization: `Bearer ${refresh}` }
          });
          localStorage.setItem('ap_token', res.data.access_token);
          error.config.headers.Authorization = `Bearer ${res.data.access_token}`;
          return API(error.config);
        } catch {
          localStorage.removeItem('ap_token');
          localStorage.removeItem('ap_refresh');
        }
      }
    }
    return Promise.reject(error);
  }
);

export default API;
export { BACKEND_URL, API_BASE };
